/*/
 * Select placeholder
/*/
	const siteSelects = document.querySelectorAll('.form-control-select')

	if (siteSelects) {
		siteSelects.forEach(e => {
			e.addEventListener('change', _ => {
				if (e.value !== '') {
					e.classList.add('is--selected')
				} else {
					e.classList.remove('is--selected')
				}
			})
		})
	}
